import { z } from "zod";
export const PageQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(20),
    cursor: z.string().min(1).optional(),
});
export function page(item) {
    return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}
//# sourceMappingURL=pagination.js.map